export default function Worker_fn() {
  return new Worker(__webpack_public_path__ + "FileUploadWorker-3327efd0e7bd4d764c1f.worker.js");
}
